export default __webpack_public_path__ + "static/OptimaNovaLTProLight-9b2cf938d3636aff27d02b72dfd9e5c1.woff";